import { FC } from 'react'

const SplashScreen: FC = () => {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-[var(--brand-dark)] overflow-hidden">
      <div className="flex flex-col items-center space-y-8 relative z-10">
        <img src="/logo_posacheck_neg.png" alt="Posacheck Logo" className="w-64 object-contain drop-shadow-lg" />
        <span className="spinner spinner-lg" style={{ borderColor: 'rgba(255,255,255,0.15)', borderTopColor: 'var(--brand-red)' }} />
      </div>
    </div>
  )
}

export default SplashScreen
